"use client";
import classNames from "classnames";
import CloseSvg from "src/components/svg/CloseSvg";
import styles from "./VotingForm.module.css";
import { useRouter } from "next/router";
import OverlayPortal from "src/components/overlayportal/OverlayPortal";
import { useCallback, useEffect, useState } from "react";
import { CSSProperties } from "styled-components";
import { useSearchParams } from "next/navigation";
//#region [Props]
type VotingResponseProps = {
    className?: string;
    title: string;
    message: string;
    style?: CSSProperties;
};
//#endregion

//#region [Component]
export default function VotingResponse({ title, className, message, style }: VotingResponseProps) {
    const router = useRouter();
    const searchParams = useSearchParams();
    const [showResponse, setShowResponse] = useState(false);

    useEffect(() => {
        const isVerified = searchParams?.get("verified");
        if (isVerified === "1") {
            setShowResponse(true);
        }
    }, [searchParams]);

    const doClose = useCallback(() => {
        setShowResponse(false);
        router?.replace(router.pathname);
    }, [router]);

    if (showResponse) {
        return <OverlayPortal doClose={doClose} hideClose style={style}>
            <div className={styles.FormAligner}>
                <div className={classNames(styles.VotingForm, className)}>
                    <div className={styles.InnerForm}>
                        <div className={styles.FormTitle}><span>{title}</span></div>
                        <div className={styles.StatusContainer}>
                            <p>{message}</p>
                        </div>
                        <button className={styles.CloseButton} onClick={doClose}><CloseSvg /></button>

                    </div>

                </div>
            </div>
        </OverlayPortal>;
    }

    return null;
}
//#endregion
